import { KpiCard } from '@evi/ui';
import { useDashboardStats } from '@/hooks/useDashboardStats';
import { formatCurrency } from './_lib';

/**
 * All-time revenue (Warren, 28 Oct 2026: "Revenue Today / All time
 * Revenue" across the top of the EVI team's dashboard). GET
 * /dashboard/stats revenue.total: cost.total summed over every completed,
 * user-stopped and system-stopped session in the caller's dashboard scope,
 * the definition Revenue today uses, with no date bound. One figure in
 * USD, formatted exactly like Revenue today: a session billed in another
 * currency (a Canadian site or home) is added at face value, not
 * converted, the same as on that tile. The muted line is the same sum
 * over the last 30 days, from the same reply. Refreshed every 60 s
 * (hooks/useDashboardStats.ts), not on live session events.
 *
 * `fit`: a seven-figure total stays on one line, sized to the tile, from
 * 1024 to 1920 px (packages/ui themes/kpiFit.ts); the label and the
 * 30-day line wrap at a word when the tile is narrow.
 */
export default function KpiRevenueAllTime() {
  const q = useDashboardStats();
  const revenue = q.data?.revenue;
  return (
    <KpiCard
      fit
      label="All-time revenue"
      value={revenue ? formatCurrency(revenue.total) : '...'}
      meta={revenue ? `${formatCurrency(revenue.last_30_days)} last 30 days` : undefined}
    />
  );
}
